const prefix = '@@section-table/';

export const SECTION_TABLE_INITIALIZE = prefix + 'INITIALIZE';
export const SECTION_TABLE_DESTROY = prefix + 'DESTROY';

export const SECTION_TABLE_SET_DATA = prefix + 'SET_DATA';
export const SECTION_TABLE_SET_LOADER = prefix + 'SET_LOADER'; 
export const SECTION_TABLE_SET_ERROR = prefix + 'SET_ERROR'; 

export const SECTION_TABLE_GET_DATA = prefix + 'SET_DATA';
